import React from 'react';
import { PageTabs, PageTabsBar } from '@liscio/ui';

const STATUS_TABS = [
  { value: 'Open', label: 'Open Tasks' },
  { value: 'Review', label: 'Pending Review' },
  { value: 'Archive', label: 'Archived' },
];
const DRAFT_TAB = { value: 'Draft', label: 'Draft' };

/** The statuses a Tasks page link (`/all_tasks?status=Review`) can open on. */
export const TASK_STATUSES = [...STATUS_TABS, DRAFT_TAB].map(
  (tab) => tab.value,
);

/**
 * The Tasks page's status tabs, as the firm page tabs of the Files and Smart Tax pages. With
 * `statusHref`, each tab links the URL that opens it.
 */
const StatusTab = ({ taskStatus, records, data, handleStatus, statusHref }) => {
  const tabs = data?.homedata?.is_employee
    ? [...STATUS_TABS, DRAFT_TAB]
    : STATUS_TABS;

  return (
    <PageTabsBar>
      <PageTabs
        aria-label="Tasks tab"
        value={
          tabs.some((tab) => tab.value === taskStatus) ? taskStatus : false
        }
        onChange={handleStatus}
        options={tabs.map((tab) => ({
          ...tab,
          count: records?.[`${tab.value}_total`],
          href: statusHref?.(tab.value),
        }))}
      />
    </PageTabsBar>
  );
};

export default StatusTab;
